<template>
  <div class="mt-4 px-4 container-fluid">
    <div class="breadcrumb text-md px-0 mb-4">
      <p>
        <span class="breadcrumb-item" @click="$router.push('/dashboard')">Inicio</span>
        <span v-if="campana"> &gt; <span class="breadcrumb-item" @click="$router.push('/campanas')">Campañas</span></span>
        &gt; Landings
      </p>
    </div>
  </div>

  <div class="px-4 container-fluid">

    <!-- ── Selector de contexto (acceso desde menú) ── -->
    <div v-if="!campanaIdFijo" class="card lnd-selector mb-4">
      <div class="lnd-selector-body">
        <div class="lnd-selector-field">
          <label class="lnd-label">Tipster</label>
          <select v-model="tipsterSelId" class="form-control form-control-sm" @change="onTipsterChange">
            <option value="">— Selecciona un tipster —</option>
            <option v-for="t in tipsters" :key="t.id" :value="t.id">{{ t.nombre }}</option>
          </select>
        </div>
        <div class="lnd-selector-field">
          <label class="lnd-label">Campaña</label>
          <select v-model="campanaSelId" class="form-control form-control-sm" :disabled="!tipsterSelId || cargandoCampanas" @change="onCampanaChange">
            <option value="">— Selecciona una campaña —</option>
            <option v-for="c in campanasDelTipster" :key="c.id" :value="c.id">{{ c.nombre }}</option>
          </select>
        </div>
      </div>
    </div>

    <!-- ── Info de la campaña seleccionada ── -->
    <div v-if="campana" class="lnd-info-bar mb-3">
      <div class="lnd-info-main">
        <i class="fa fa-bullhorn lnd-info-icon"></i>
        <span class="lnd-info-nombre">{{ campana.nombre }}</span>
        <span class="lnd-info-sep">·</span>
        <span class="lnd-info-canal">{{ campana.nomcanal || campana.canal }}</span>
      </div>
      <div class="lnd-info-enlace">
        <a :href="campana.enlace" target="_blank" class="lnd-enlace-link">{{ campana.enlace }}</a>
        <button class="lnd-copy-btn" @click="copiar(campana.enlace)" title="Copiar enlace">
          <i class="fa" :class="copiadoEnlace ? 'fa-check' : 'fa-copy'"></i>
        </button>
      </div>
    </div>

    <!-- ── Barra de acciones ── -->
    <div v-if="campana" class="lnd-toolbar mb-3">
      <button class="lnd-btn-nueva" @click="abrirNuevaLanding">
        <i class="fa fa-plus me-1"></i> Nueva Landing
      </button>
      <span class="lnd-count">{{ landings.length }} landing{{ landings.length !== 1 ? 's' : '' }}</span>
    </div>

    <!-- ── Estado de carga ── -->
    <div v-if="cargandoLandings" class="lnd-state">
      <i class="fa fa-spinner fa-spin"></i>
      <span>Cargando landings…</span>
    </div>
    <div v-else-if="errorLandings" class="lnd-state lnd-state--error">
      <i class="fa fa-exclamation-circle"></i>
      <span>{{ errorLandings }}</span>
    </div>

    <!-- ── Tabla de landings ── -->
    <div v-else-if="campana" class="card ficha-listado mt-0">
      <div class="px-4 pb-0 card-body">
        <div class="table-responsive mb-4">
          <table class="table table-flush table-listado">
            <thead class="thead-light">
              <tr>
                <th>Mercado</th>
                <th>Tipo campaña</th>
                <th>Tipo audiencia</th>
                <th>Mes</th>
                <th>Segmentación</th>
                <th>Idioma</th>
                <th>Plantilla</th>
                <th>Estado</th>
                <th>URL</th>
                <th class="sin-orden">Acciones</th>
              </tr>
            </thead>
            <tbody class="text-sm">
              <tr v-if="!landings.length">
                <td colspan="10" class="text-center py-4">
                  <div class="lnd-empty-inline">
                    <i class="fa fa-rocket mb-2" style="font-size:1.5rem;opacity:.3"></i>
                    <p class="mb-2" style="opacity:.5">No hay landings para esta campaña.</p>
                    <button class="lnd-btn-nueva" @click="abrirNuevaLanding">
                      <i class="fa fa-plus me-1"></i> Crear primera landing
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-for="l in landings" :key="l.id">
                <td><span class="lnd-badge lnd-badge--mercado">{{ l.mercado || '—' }}</span></td>
                <td><span class="lnd-badge lnd-badge--campana">{{ l.tipo_campana || '—' }}</span></td>
                <td class="lnd-cell-aud">{{ l.tipo_audiencia || '—' }}</td>
                <td class="lnd-cell-mes">{{ l.mes || '—' }}</td>
                <td class="lnd-cell-seg">{{ l.tipo_segmentacion || '—' }}</td>
                <td><span class="lnd-badge lnd-badge--idioma">{{ idiomaLabel(l.idioma_efectivo) }}</span></td>
                <td>
                  <span class="lnd-tpl-nombre">{{ l.template?.nombre || '—' }}</span>
                  <span v-if="l.template?.categoria" class="lnd-cat ms-1" :class="'lnd-cat--' + l.template.categoria">
                    {{ catLabel(l.template.categoria) }}
                  </span>
                </td>
                <td>
                  <span class="lnd-estado" :class="'lnd-estado--' + l.estado">
                    <i class="fa" :class="estadoIcon(l.estado)"></i>
                    {{ estadoLabel(l.estado) }}
                  </span>
                </td>
                <td>
                  <div v-if="l.url_publica" class="lnd-url-cell">
                    <a :href="l.url_publica" target="_blank" class="lnd-url-link">{{ l.url_publica.replace(/^https?:\/\/[^/]+/, '') }}</a>
                    <button class="lnd-copy-btn" @click="copiar(l.url_publica)" title="Copiar URL">
                      <i class="fa fa-copy"></i>
                    </button>
                  </div>
                  <span v-else class="text-muted">—</span>
                </td>
                <td class="lnd-acciones">
                  <a href="#" class="cursor-pointer me-2" title="Editar diseño" @click.prevent="editarLanding(l.id)">
                    <i class="fas fa-edit text-secondary"></i>
                  </a>
                  <a href="#" class="cursor-pointer me-2" title="Editar parámetros" @click.prevent="editarParametros(l)">
                    <i class="fas fa-sliders-h text-secondary"></i>
                  </a>
                  <a href="#" class="cursor-pointer me-2" title="Vista previa móvil" @click.prevent="abrirPreview(l)">
                    <i class="fas fa-mobile-alt text-secondary"></i>
                  </a>
                  <!-- Botón Meta Ads: solo usuarios con permiso meta.crear_campana y landing publicada -->
                  <a v-if="puedeCampanaMeta && l.url_publica"
                     href="#" class="cursor-pointer me-2" title="Crear campaña Meta"
                     @click.prevent="abrirMetaCampana(l)">
                    <i class="fab fa-meta" style="color:#1877f2"></i>
                  </a>
                  <a href="#" class="cursor-pointer" title="Eliminar" @click.prevent="confirmarBorrar(l)">
                    <i class="fas fa-trash text-secondary"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- ── Placeholder cuando no hay campaña seleccionada ── -->
    <div v-else-if="!campanaIdFijo && !campana" class="lnd-state">
      <i class="fa fa-rocket fa-2x mb-2" style="opacity:.3"></i>
      <p style="opacity:.5">Selecciona un tipster y una campaña para ver sus landings.</p>
    </div>

  </div>

  <!-- ── Modals ── -->
  <ModalSeleccionLanding
    :modalActive="modalNuevaActive"
    :campanaId="campanaActualId"
    @cerrar-modal="modalNuevaActive = false"
    @guardado="cargarLandings"
  />

  <ModalEditarLanding
    :modalActive="modalEditarActive"
    :landingId="editarLandingId"
    @cerrar-modal="modalEditarActive = false"
    @guardado="cargarLandings"
  />

  <ModalEditarParametros
    :modalActive="modalParamsActive"
    :landing="editarParamsLanding"
    @cerrar-modal="modalParamsActive = false"
    @guardado="cargarLandings"
  />

  <ModalMetaCampana
    :modalActive="modalMetaActive"
    :landingId="metaLanding?.id || 0"
    :landingNombre="metaLanding?.template?.nombre || ''"
    :tipsterNombre="campana?.nombre || ''"
    :landingMercado="metaLanding?.mercado || ''"
    @cerrar-modal="modalMetaActive = false"
    @campaña-creada="cargarLandings"
  />

  <!-- ── Modal preview móvil ── -->
  <div v-if="previewActive" class="overlay" @click.self="previewActive = false">
    <div class="lnd-preview-box">
      <div class="lnd-preview-header">
        <span class="lnd-preview-title"><i class="fa fa-mobile-alt me-1"></i> Vista previa móvil</span>
        <button class="lnd-preview-close" @click="previewActive = false"><i class="fa fa-times"></i></button>
      </div>
      <div class="lnd-preview-phone">
        <div v-if="previewCargando" class="lnd-preview-loading">
          <i class="fa fa-spinner fa-spin"></i>
        </div>
        <iframe
          v-else
          class="lnd-preview-iframe"
          :srcdoc="previewHtml"
          sandbox="allow-scripts allow-same-origin"
          scrolling="yes"
          title="Vista previa"
        ></iframe>
      </div>
    </div>
  </div>

  <!-- ── Confirm borrar ── -->
  <div v-if="confirmVisible" class="overlay">
    <div class="confirm-box">
      <p class="mt-4 mb-4">¿Eliminar la landing <strong>{{ borrarLanding?.template?.nombre }}</strong>?</p>
      <table class="mt-4 mb-4"><tr>
        <td width="50%"><button class="btn btn-secondary w-100" @click="confirmVisible = false">Cancelar</button></td>
        <td width="50%"><button class="btn btn-danger w-100 ms-2" @click="ejecutarBorrar">Eliminar</button></td>
      </tr></table>
    </div>
  </div>
</template>

<script>
import campanasService from '@/services/campanas.service.js';
import ModalSeleccionLanding from './components/ModalSeleccionLanding.vue';
import ModalEditarLanding from './components/ModalEditarLanding.vue';
import ModalEditarParametros from './components/ModalEditarParametros.vue';
import ModalMetaCampana from './components/ModalMetaCampana.vue';

const CAT_LABELS = {
  clasica:        'Clásica',
  foto:           'Foto',
  minimal:        'Minimal',
  especial:       'Especial',
  'especial-foto':'Esp. foto',
};

export default {
  name: 'Landings',
  components: { ModalSeleccionLanding, ModalEditarLanding, ModalEditarParametros, ModalMetaCampana },

  data() {
    return {
      // modo fijo (desde botón de campaña): campanaIdFijo != 0
      campanaIdFijo: 0,

      // selector de contexto (desde menú)
      tipsters: [],
      tipsterSelId: '',
      campanasDelTipster: [],
      campanaSelId: '',
      cargandoCampanas: false,

      // campaña activa
      campana: null,

      // landings
      landings: [],
      cargandoLandings: false,
      errorLandings: '',

      // modals
      modalNuevaActive: false,
      modalEditarActive: false,
      editarLandingId: 0,
      modalParamsActive: false,
      editarParamsLanding: null,

      // preview móvil
      previewActive: false,
      previewHtml: '',
      previewCargando: false,

      // confirm borrar
      confirmVisible: false,
      borrarLanding: null,

      // feedback copiar
      copiadoEnlace: false,

      // modal Meta Campaigns
      modalMetaActive: false,
      metaLanding: null,
    };
  },

  computed: {
    campanaActualId() {
      return this.campana?.id || 0;
    },
    miRol() {
      return this.$store.getters['auth/rolEfectivo'];
    },
    puedeCampanaMeta() {
      return (this.$store.getters['auth/permisos'] || []).includes('meta.crear_campana');
    },
  },

  async mounted() {
    const qId = Number(this.$route.query.campana_id);
    if (qId) {
      this.campanaIdFijo = qId;
      // Carga info de campaña desde query params (pasados por Campanas.vue)
      this.campana = {
        id:       qId,
        nombre:   this.$route.query.nombre   || '—',
        enlace:   this.$route.query.enlace   || '',
        nomcanal: this.$route.query.canal    || '',
      };
      await this.cargarLandings();
    } else {
      await this.cargarTipsters();
    }
  },

  methods: {
    // ── Carga tipsters (modo menú) ─────────────────────────
    async cargarTipsters() {
      try {
        const data = await campanasService.campanasTipsters();
        this.tipsters = data.tipsters || data || [];
      } catch {
        this.tipsters = [];
      }
    },

    async onTipsterChange() {
      this.campanaSelId = '';
      this.campana = null;
      this.landings = [];
      this.campanasDelTipster = [];
      if (!this.tipsterSelId) return;

      this.cargandoCampanas = true;
      try {
        const data = await campanasService.campanasSimple({ tipster_id: this.tipsterSelId });
        this.campanasDelTipster = data.campanas || data.data || [];
      } catch {
        this.campanasDelTipster = [];
      } finally {
        this.cargandoCampanas = false;
      }
    },

    async onCampanaChange() {
      this.campana = null;
      this.landings = [];
      if (!this.campanaSelId) return;
      const found = this.campanasDelTipster.find(c => c.id === this.campanaSelId || c.id === Number(this.campanaSelId));
      if (found) {
        this.campana = found;
        await this.cargarLandings();
      }
    },

    // ── Carga landings de la campaña ──────────────────────
    async cargarLandings() {
      if (!this.campanaActualId) return;
      this.cargandoLandings = true;
      this.errorLandings = '';
      try {
        const data = await campanasService.landingListar(this.campanaActualId);
        this.landings = data.landings || [];
      } catch {
        this.errorLandings = 'No se pudieron cargar las landings.';
      } finally {
        this.cargandoLandings = false;
      }
    },

    // ── Nueva landing ─────────────────────────────────────
    abrirNuevaLanding() {
      this.modalNuevaActive = true;
    },

    // ── Editar landing ────────────────────────────────────
    editarLanding(id) {
      this.editarLandingId = id;
      this.modalEditarActive = true;
    },

    // ── Editar parámetros ─────────────────────────────────
    editarParametros(landing) {
      this.editarParamsLanding = landing;
      this.modalParamsActive = true;
    },

    // ── Vista previa móvil ────────────────────────────────
    async abrirPreview(landing) {
      this.previewActive = true;
      this.previewHtml = '';
      this.previewCargando = true;
      try {
        this.previewHtml = await campanasService.landingVistaPrevia(landing.id);
      } catch {
        this.previewHtml = '<p style="color:#f66;padding:20px">No se pudo cargar la vista previa.</p>';
      } finally {
        this.previewCargando = false;
      }
    },

    // ── Borrar landing ────────────────────────────────────
    abrirMetaCampana(landing) {
      this.metaLanding    = landing;
      this.modalMetaActive = true;
    },

    confirmarBorrar(landing) {
      this.borrarLanding = landing;
      this.confirmVisible = true;
    },

    async ejecutarBorrar() {
      if (!this.borrarLanding) return;
      try {
        await campanasService.landingBorrar(this.borrarLanding.id);
        this.confirmVisible = false;
        this.borrarLanding = null;
        await this.cargarLandings();
      } catch {
        this.confirmVisible = false;
      }
    },

    // ── Copiar ────────────────────────────────────────────
    async copiar(texto) {
      try {
        await navigator.clipboard.writeText(texto);
        this.copiadoEnlace = true;
        setTimeout(() => { this.copiadoEnlace = false; }, 2000);
      } catch { /* noop */ }
    },

    // ── Helpers ───────────────────────────────────────────
    idiomaLabel(code) {
      return (code || 'es').toUpperCase();
    },
    catLabel(cat) { return CAT_LABELS[cat] || cat || ''; },

    estadoLabel(e) {
      return { publicada: 'Publicada', borrador: 'Borrador', pausada: 'Pausada' }[e] || e;
    },
    estadoIcon(e) {
      return { publicada: 'fa-check-circle', borrador: 'fa-circle-o', pausada: 'fa-pause-circle' }[e] || 'fa-circle';
    },
  },
};
</script>

<style scoped>
/* ── Selector contexto ───────────────────────── */
.lnd-selector { padding: 16px 20px; }
.lnd-selector-body {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  align-items: flex-end;
}
.lnd-selector-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 200px;
  flex: 1;
}
.lnd-label {
  font-size: .7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: var(--q-muted);
}

/* ── Info bar campaña ────────────────────────── */
.lnd-info-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  background: var(--q-card-alt, #10171f);
  border: 1px solid var(--q-border, #1e2d3a);
  border-radius: 8px;
  padding: 10px 16px;
}
.lnd-info-main {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.lnd-info-icon { color: var(--q-gold, #d4af37); font-size: .85rem; }
.lnd-info-nombre { font-weight: 700; font-size: .9rem; color: var(--q-text); }
.lnd-info-sep { color: var(--q-muted); }
.lnd-info-canal { font-size: .82rem; color: var(--q-muted); }
.lnd-info-enlace { display: flex; align-items: center; gap: 6px; }
.lnd-enlace-link {
  font-family: var(--q-font-mono, monospace);
  font-size: .75rem;
  color: var(--q-green, #00e676);
  text-decoration: none;
  word-break: break-all;
}
.lnd-enlace-link:hover { text-decoration: underline; }

/* ── Toolbar ─────────────────────────────────── */
.lnd-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.lnd-btn-nueva {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--q-gold, #d4af37);
  color: var(--q-gold-on, #000);
  border: none;
  border-radius: 6px;
  font-size: .82rem;
  font-weight: 700;
  padding: 7px 16px;
  cursor: pointer;
  transition: opacity .15s;
}
.lnd-btn-nueva:hover { opacity: .85; }
.lnd-count {
  font-size: .78rem;
  color: var(--q-muted);
}

/* ── Empty inline (dentro de la tabla) ──────── */
.lnd-empty-inline {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  color: var(--q-muted);
}

/* ── Badges tabla ────────────────────────────── */
.lnd-badge {
  display: inline-block;
  font-size: .68rem;
  font-weight: 700;
  letter-spacing: .05em;
  border-radius: 4px;
  padding: 2px 7px;
}
.lnd-badge--mercado  { background: rgba(51,176,255,.12); color: #60b0ff; }
.lnd-badge--campana  { background: rgba(212,175,55,.12); color: var(--q-gold, #d4af37); }
.lnd-badge--idioma   { background: rgba(160,100,255,.12); color: #c084fc; letter-spacing: .03em; }

/* ── Celdas tabla ────────────────────────────── */
.lnd-cell-aud, .lnd-cell-seg { font-size: .78rem; color: var(--q-text); }
.lnd-cell-mes { font-size: .78rem; color: var(--q-muted); white-space: nowrap; }
.lnd-tpl-nombre { font-size: .82rem; font-weight: 600; color: var(--q-text); }

/* Categorías */
.lnd-cat {
  font-size: .6rem; font-weight: 700; text-transform: uppercase; letter-spacing: .04em;
  border-radius: 3px; padding: 1px 5px; flex-shrink: 0;
  background: var(--q-border); color: var(--q-muted);
}
.lnd-cat--clasica       { background: #0c2a1a; color: var(--q-green, #00e676); }
.lnd-cat--foto          { background: #1a1a0c; color: var(--q-gold, #d4af37); }
.lnd-cat--minimal       { background: #0a1828; color: #60b0ff; }
.lnd-cat--especial      { background: #2c1216; color: var(--q-red, #ff4444); }
.lnd-cat--especial-foto { background: #1a0a2e; color: #c084fc; }

/* Estado */
.lnd-estado {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: .68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .04em;
  border-radius: 4px;
  padding: 2px 7px;
  white-space: nowrap;
  flex-shrink: 0;
}
.lnd-estado--publicada { background: rgba(0,230,118,.12); color: #00e676; }
.lnd-estado--borrador  { background: rgba(160,160,160,.1); color: var(--q-muted); }
.lnd-estado--pausada   { background: rgba(255,180,0,.12); color: #ffb400; }

/* URL en tabla */
.lnd-url-cell {
  display: flex;
  align-items: center;
  gap: 5px;
}
.lnd-url-link {
  flex: 1;
  font-family: var(--q-font-mono, monospace);
  font-size: .72rem;
  color: var(--q-green, #00e676);
  text-decoration: none;
  word-break: break-all;
}
.lnd-url-link:hover { text-decoration: underline; }

/* Botón copiar genérico */
.lnd-copy-btn {
  background: transparent;
  border: 1px solid var(--q-border-md, #2a3d50);
  border-radius: 4px;
  color: var(--q-muted);
  padding: 2px 7px;
  cursor: pointer;
  font-size: .75rem;
  flex-shrink: 0;
  transition: color .15s;
}
.lnd-copy-btn:hover { color: var(--q-green, #00e676); border-color: var(--q-green, #00e676); }

/* ── Estado genérico ─────────────────────────── */
.lnd-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  color: var(--q-muted);
  font-size: .9rem;
  text-align: center;
  gap: 8px;
}
.lnd-state--error { color: var(--q-red, #ff4444); }

/* Celda acciones */
.lnd-acciones { white-space: nowrap; }

/* ── Modal preview móvil ─────────────────────── */
.lnd-preview-box {
  background: var(--q-card, #0e141f);
  border: 1px solid var(--q-border, #1e2d3a);
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  gap: 16px;
  max-height: 90vh;
}
.lnd-preview-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.lnd-preview-title {
  font-size: .85rem;
  font-weight: 700;
  color: var(--q-text);
}
.lnd-preview-close {
  background: transparent;
  border: none;
  color: var(--q-muted);
  font-size: 1.1rem;
  cursor: pointer;
  padding: 2px 8px;
  border-radius: 4px;
}
.lnd-preview-close:hover { color: var(--q-red, #ff4444); }

/* Marco del teléfono */
.lnd-preview-phone {
  width: 375px;
  height: 667px;
  border: 3px solid var(--q-border-md, #2a3d50);
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  background: #000;
  box-shadow: 0 0 40px rgba(0,0,0,.6);
  flex-shrink: 0;
}
.lnd-preview-loading {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: var(--q-muted);
}
.lnd-preview-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

/* ── Responsive ──────────────────────────────── */
@media (max-width: 600px) {
  .lnd-info-bar { flex-direction: column; align-items: flex-start; }
  .lnd-grid { grid-template-columns: 1fr; }
  .lnd-selector-body { flex-direction: column; }
  .lnd-preview-phone { width: 320px; height: 568px; }
}
</style>
